import { useNavigation } from '@react-navigation/native';
import type { StackNavigationProp } from '@react-navigation/stack';
import { getRequiredScreensToLogin } from '~/navigation/types';
import type { RootStackParamList } from '~/navigation/types';
import { useUserInfoStore } from '~/stores/userInfo';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

function useAppNavigation() {
  const originalNavigation =
    useNavigation<StackNavigationProp<RootStackParamList>>();

  function navigationMiddleware(
    action: 'navigate' | 'replace' | 'push',
    ...args: any
  ) {
    const hasUser = !!useUserInfoStore.getState().user;
    const screensRequiredToLogin = getRequiredScreensToLogin();
    if (
      !MarisaAppUtils.goToLogin ||
      !screensRequiredToLogin[args[0] as keyof RootStackParamList] ||
      hasUser
    ) {
      originalNavigation[action](...args);
    } else {
      MarisaAppUtils.goToLogin();
    }
  }

  const navigation = {
    ...originalNavigation,
    navigate: (...args: any) => {
      navigationMiddleware('navigate', ...args);
    },
    push: (...args: any) => {
      navigationMiddleware('push', ...args);
    },
    replace: (...args: any) => {
      navigationMiddleware('replace', ...args);
    },
  };
  return navigation as StackNavigationProp<RootStackParamList>;
}

export default useAppNavigation;
